var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',_vm._b({attrs:{"height":'auto',"headers":_vm.headers,"items":_vm.items,"dense":"","footer-props":{
    showCurrentPage: true,
    showFirstLastPage: true,
    itemsPerPageOptions: [5, 10, 50, 100],
  }},scopedSlots:_vm._u([_vm._l((this.headers),function(header){return {key:`item.${header.value}`,fn:function({ item }){return [(_vm.columnIsNumber(header, item))?_c('span',{key:header.value},[_vm._v(_vm._s(_vm.thousandsSeparator(item[header.value]))+" ")]):_c('span',{key:header.value},[_vm._v(_vm._s(item[header.value]))])]}}})],null,true)},'v-data-table',_vm.propsdinamic,false))
}
var staticRenderFns = []

export { render, staticRenderFns }